import {connect} from 'react-redux'

import {setSidebarClosed, setSelectedRequestWidget} from 'Store/Actions'
import {AppDispatch} from 'Store'
import {InterviewInvitationListItem} from './InterviewInvitationListItem'
import {IncomingRequestType} from 'Interfaces'

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setSelectedRequestWidget: (request: IncomingRequestType) =>
    dispatch(setSelectedRequestWidget(request)),
  setSidebarClosed: (sidebarClosed: boolean) =>
    dispatch(setSidebarClosed(sidebarClosed)),
})

export const InterviewInvitationListItemContainer = connect(
  null,
  mapDispatchToProps
)(InterviewInvitationListItem)
